import type { NativeStackNavigationOptions } from '@react-navigation/native-stack';
import type { StackNavigationOptions } from '@react-navigation/stack';
import { IconChevronLeft, IconX } from '@tabler/icons-react-native';
import { Button } from 'app/design/primitives/button';
import type { Theme } from 'app/shopify';
import type { ScreenOptionsNavigationProp, SpecificRouteProp } from 'app/types/navigation';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { HeaderLeftEmpty } from './header-placeholders';
import { ModalLogoComponent } from './mobile/modal-logo';

/**
 * This should be applied to modal navigators, that is
 * when a navigator is shown modally but acts as a standalone
 * navigation stack.
 */
export function createModalNavigatorOptions(
  navigation: ScreenOptionsNavigationProp,
  route: SpecificRouteProp,
  theme: Theme,
) {
  const screenOptions: NativeStackNavigationOptions | StackNavigationOptions = {
    headerTitle: () => <ModalLogoComponent />,
  };

  const state = navigation.getState();
  const isFirstInStack = state.index === 0;
  const isFocused = state.index === state.routes.findIndex((candidate) => candidate.key === route.key);

  screenOptions.headerLeft = isFocused
    ? () => (
        <Button onPress={navigation.goBack} testID="modal-close-button">
          {isFirstInStack ? (
            <IconX strokeWidth={ICON_STROKE_WIDTH} color={theme.colors['white-label.header.on-header']} />
          ) : (
            <IconChevronLeft strokeWidth={ICON_STROKE_WIDTH} color={theme.colors['white-label.header.on-header']} />
          )}
        </Button>
      )
    : HeaderLeftEmpty;
  return screenOptions;
}
